export function copyWithSnackbar({ copyText, showSnackbar, text, successText = 'COPIED' }) {
  return copyText(text).then(() => {
    showSnackbar(successText);
  });
}
